import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const FuelConsumptionIndividualReport = new Module({
  id: 'fuel-consumption-report-individual',
  name: 'Fuel Consumption Report (Individual)',
  path: 'fuel-consumption-individual',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/FuelConsumptionIndividual'))
  )
});
